import React from "react"
import TabsView from "../TabView"

function Presentation(props) {
  return (
    <div>
      <TabsView {...props} />
    </div>
  )
}

export default Presentation
